import { apiInfo, fetchRequest, HTTPMethod, Resource } from './api';

export const sendConfirmationEmail = (data) => {
    return fetchRequest(HTTPMethod.POST, `${apiInfo.base}/${Resource.EMAILS}`, data);
};
